module.exports = __webpack_public_path__ + "static/media/dropdownFilter.e5354347.svg";